var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"bar-cla"},[_c('div',{style:(_vm.itemStyle)}),_vm._v(" "),_c('div',{style:(_vm.itemStyle)}),_vm._v(" "),_c('div',{style:(_vm.itemStyle)}),_vm._v(" "),_c('div',{style:(_vm.itemStyle)}),_vm._v(" "),_c('div',{style:(_vm.itemStyle)})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe49a89","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadding.vue
// module id = null
// module chunks = 